import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import type { Submission } from '../../../lib/comeet/submit/submissionSchema';
import { trackRequestMetrics } from '../../lib/trackRequestMetrics';

export const submitApplication = async (answers: Submission, turnstileToken?: string | null): Promise<void> => {
    await trackRequestMetrics(
        axios.post(pathfinder('job_apply'), { ...answers, turnstile_token: turnstileToken ?? undefined }),
        'job_apply'
    );
};
